module.exports = __webpack_public_path__ + "static/media/U1-T2-2-2b.541be405.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-2b.svg
// module id = 541
// module chunks = 0